import pluralize from 'pluralize';
import { memo } from 'react';

import { FileStatusButton, FileStatusIconCompleted, FileStatusTitle } from '@air/feature-file-status/ui';
import { Close } from '@air/next-icons';

import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { type AssetCustomFieldValueUpdateTask, type GetCompletedMetadata } from '~/store/tasks/types';

export type AssetCustomFieldValueUpdateTaskCompletedPanelItemProps = {
  metadata: GetCompletedMetadata<AssetCustomFieldValueUpdateTask>;
  onClear: () => void;
};

export const AssetCustomFieldValueUpdateTaskCompletedPanelItem = memo(
  ({ metadata, onClear }: AssetCustomFieldValueUpdateTaskCompletedPanelItemProps) => {
    const updatedCount = metadata.updatedAssetsCount ?? metadata.assetIds?.length ?? 0;

    return (
      <PaneItemTW
        avatar={<FileStatusIconCompleted />}
        title={
          <FileStatusTitle data-testid="ASSET_CUSTOM_FIELD_VALUE_UPDATE_TASK_COMPLETED_PANEL_ITEM_TITLE">
            Custom fields updated
          </FileStatusTitle>
        }
        subtitle={
          updatedCount > 0 ? (
            <span className="text-12 text-grey-11">{pluralize('asset', updatedCount, true)} updated</span>
          ) : undefined
        }
        buttons={
          <FileStatusButton label="Clear" onClick={onClear}>
            <Close className="size-4" />
          </FileStatusButton>
        }
      />
    );
  },
);

AssetCustomFieldValueUpdateTaskCompletedPanelItem.displayName = 'AssetCustomFieldValueUpdateTaskCompletedPanelItem';
